import script from "./ProcessTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessTable.vue?vue&type=script&setup=true&lang=js"

import "./ProcessTable.vue?vue&type=style&index=0&id=6d2f8b57&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2f8b57"]])

export default __exports__